// Webpack Imports
import * as bootstrap from 'bootstrap';


class Altidrone {

    /**
     * @type { Altidrone }
     */
    static instance;

    /**
     * @type { HTMLElement }
     */
    static benefitsAccordionElement;


    constructor() {

        if (!Altidrone.instance) {
            this.initializeServicesHoverState();
        }

        Altidrone.instance = this;
    }

    /**
     * Add class on service in Services service section when mouse is hover.
     */
    initializeServicesHoverState() {

        /** @type { HTMLElement } container **/
        const container = document.querySelector(".section-services .services-container");

        if (!container) {
            return;
        }

        /** @type { NodeListOf<HTMLElement> } services **/
        const services = container.querySelectorAll(".type-service");

        if (services.length === 0) {
            return;
        }

        /**
         * @param { number} index
         */
        function setHoverState(index) {
            container.classList.add('has-hover', `hover-${index}`);
        }

        /**
         * @param { number} index
         */
        function removeHoverState(index) {
            container.classList.remove('has-hover', `hover-${index}`);
        }

        services.forEach((service, index) => {
            service.addEventListener("mouseenter", () => setHoverState(index + 1));
            service.addEventListener("mouseleave", () => removeHoverState(index + 1));
        });
    }


    initializeBenefitsAccordion() {

    }

}


(function () {
    'use strict';

    // Focus input if Searchform is empty
    [].forEach.call(document.querySelectorAll('.search-form'), (el) => {
        el.addEventListener('submit', function (e) {
            var search = el.querySelector('input');
            if (search.value.length < 1) {
                e.preventDefault();
                search.focus();
            }
        });
    });


    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'focus',
        });
    });


    new Altidrone();
})();

